module.exports = __webpack_public_path__ + "static/media/imageForNotification.ef98637a.svg";